module.exports = __webpack_public_path__ + "img/04.9a3ae85f.png";